
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"currentColor","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"currentColor","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2065.96-1765.956a.451.451 0 01.338.14.463.463 0 01.136.333.444.444 0 01-.136.333.466.466 0 01-.338.132h-6.376a.463.463 0 01-.342-.132.452.452 0 01-.132-.333.471.471 0 01.132-.333.447.447 0 01.342-.14zm0-2.894a.466.466 0 01.338.132.434.434 0 01.136.324.473.473 0 01-.136.342.451.451 0 01-.338.14h-6.376a.447.447 0 01-.342-.14.482.482 0 01-.132-.342.441.441 0 01.132-.324.463.463 0 01.342-.132zm-7.525 7.717h8.832a2.533 2.533 0 001.881-.636 2.6 2.6 0 00.627-1.9v-7.63a5.757 5.757 0 00-.053-.846 1.782 1.782 0 00-.21-.623 3.1 3.1 0 00-.474-.6l-4.692-4.765a2.68 2.68 0 00-.57-.46 1.833 1.833 0 00-.61-.219 4.605 4.605 0 00-.776-.057h-3.955a2.536 2.536 0 00-1.877.636 2.589 2.589 0 00-.631 1.9v12.666a2.589 2.589 0 00.631 1.9 2.536 2.536 0 001.877.634zm.053-1.21a1.342 1.342 0 01-1-.346 1.381 1.381 0 01-.338-1v-12.616a1.361 1.361 0 01.342-.991 1.347 1.347 0 011.009-.351h3.766v4.876a1.532 1.532 0 00.373 1.127 1.506 1.506 0 001.109.373h4.815v7.577a1.21 1.21 0 01-1.359 1.351zm5.4-10.068a.507.507 0 01-.375-.122.536.536 0 01-.114-.382v-4.504l4.929 5.008z"}})])])
          )
        }
      }
    